import { NotificationService } from './../../services/NotificationService';
import { NotificationModel, MessageModel, MediaEnquetePerguntaModel, MediaEnqueteRespostaUsuarioModel, MediaEnqueteResultadoModel } from './../../model/NotificationModel';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, Loading, LoadingController, Slides } from 'ionic-angular';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { Subscription } from '../../../node_modules/rxjs';
import { GetNotificationAction, ClearNotificationsAction } from '../../store/action/NotificationActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { LogoutAction } from '../../store/action/UserActions';
import { LoginPage } from '../login/login';
import { CronosClearErrorsAction } from '../../store/action/CronosActions';

@IonicPage()
@Component({
  selector: 'page-intermarketing-details',
  templateUrl: 'intermarketing-details.html',
})
export class IntermarketingDetailsPage {

  @ViewChild('carrouselSlides') slides: Slides;
  @ViewChild('pollSlides') pollSlides: Slides;

  public id: number;
  public messageId: number;
  public item: MessageModel;
  public notificationItem: NotificationModel;

  private userStateSubscription: Subscription;
  private notificationStateSubscription: Subscription;
  
  public clientId: number = null;
  public userId: number = null;
  
  public isLoading: boolean;
  public loader: Loading;
  private loggingOff: boolean;

  public paginationVisible: boolean;
  public paginationPreviousVisible: boolean;
  public paginationNextVisible: boolean;
  public currentPage: number;
  public totalPages: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public notificationService: NotificationService,
    private store: Store<AppStore>,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) {
    this.item = null;
    if (this.navParams.get('id')) {
      this.id = this.navParams.get('id');
    }
    if (this.navParams.get('messageId')) {
      this.messageId = this.navParams.get('messageId');
    }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

  ionViewDidEnter() {
    this.userStateSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.clientId = userState.user.clienteId;
        this.userId = userState.user.id;
        this.store.dispatch(new GetNotificationAction({ clientId: this.clientId, messageId: this.messageId }));
      }
    });
    this.notificationStateSubscription = this.store.select('notificationState').subscribe(notificationState => {
      if (notificationState.loadingGet && !this.isLoading) {
        this.loader = this.loadingCtrl.create({
          content: "Aguarde..."
        });
        this.loader.present();
        this.isLoading = true;
      }
      if (!notificationState.loadingGet && this.isLoading) {
        this.loader.dismiss();
        this.isLoading = false;
      }
      if (notificationState.errorGet) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao obter as informações da notificação');
          }
        }, 200);
      }
      if (notificationState.item != null) {
        this.item = notificationState.item;
        if (notificationState.data) {
          this.notificationItem = notificationState.data.find(x => x.id == this.id);
          if (this.notificationItem != null) {
            this.item.status = this.notificationItem.status;
          }
        }
        if (this.item.tipoMensagem == 3) {
          this.notificationService.listMedia(this.clientId, this.item.id)
            .subscribe(resp => {
              this.item.midiaDataList = resp.sort(x => x.sequencia);
            }, 
            err => {
              this.presentToast('Erro ao carregar as mídias da mensagem');
            })
        } else if (this.item.tipoMensagem == 4) {
          this.notificationService.getEnquete(this.clientId, this.item.midiaMensagemId)
            .subscribe(resp => {
              this.item.midiaEnqueteData = resp;
              this.configPoll();
            },
            err => {
              this.presentToast('Erro ao carregar a mídia da mensagem');
            });
        } else if (this.item.midiaMensagemId != null && this.item.midiaData == null) {
          this.notificationService.getMedia(this.clientId, this.item.midiaMensagemId)
            .subscribe(resp => {
              this.item.midiaData = resp;
              if (this.item.midiaData.typemidia == 2) {
                setTimeout(() => {
                  this.configureVideo(this.item.midiaData.id);
                }, 100);
              }
            },
            err => {
              this.presentToast('Erro ao carregar a mídia da mensagem');
            });
        }
      }
    });
  }

  configureVideo(videoId: number) {
    const video: any = document.getElementById('video' + videoId);
    const playButton = document.getElementById('play-pause' + videoId);
    const playText = document.getElementById('play-pause-text' + videoId);
    const playIcon = document.getElementById('play-pause-icon' + videoId);
    const beginButton = document.getElementById('beginVideo' + videoId);
    const fullScreenButton = document.getElementById('full-screen' + videoId);

    playButton.addEventListener('click', function() {
      if (video.paused == true) {
        video.play();
        playIcon.className = playIcon.className.replace('play', 'pause');
        playText.innerHTML = 'Pausar';
      } else {
        video.pause();
        playIcon.className = playIcon.className.replace('pause', 'play');
        playText.innerHTML = 'Tocar';
      }
    });

    beginButton.addEventListener('click', function() {
      video.currentTime = 0;
    });

    fullScreenButton.addEventListener('click', function() {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      }
      if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
      if (video.enterFullscreen) {
        video.enterFullscreen();
      }
    });
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null) this.userStateSubscription.unsubscribe();
    if (this.notificationStateSubscription != null) this.notificationStateSubscription.unsubscribe();
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (6)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  markAsRead(showSuccessNotification: boolean) {
    let itemCopy: NotificationModel = this.notificationItem;
    itemCopy.status = 3;
    this.notificationService.updateNotification(itemCopy)
      .subscribe(resp => {
        this.item.status = 3;
        if (showSuccessNotification) {
          this.presentToast('Status da notificação atualizado!');
        }
      },
      err => {
        this.presentToast('Erro ao atualizar status da notificação');
      });
  }

  checkIfLast() {
    let currentIndex = this.slides.getActiveIndex();
    if (currentIndex == this.slides.length() - 1) {
      this.markAsRead(true);
    }
  }

  videoFinished(paginaId: number) {
    const video: any = document.getElementById('video' + paginaId);
    const playText = document.getElementById('play-pause-text' + paginaId);
    const playIcon = document.getElementById('play-pause-icon' + paginaId);
    video.pause();
    playIcon.className = playIcon.className.replace('pause', 'play');
    playText.innerHTML = 'Tocar';
    this.markAsRead(false);
  }

  controlChange() {
    if (this.pollSlides == null || this.pollSlides._slides == null) {
      setTimeout(() => { this.controlChange(); }, 100);
      return;
    }
    const type = this.pollSlides._slides[this.pollSlides.getActiveIndex()].getAttribute('data-type');
    if (type == 'question') {
      const perguntaId = parseInt(this.pollSlides._slides[this.pollSlides.getActiveIndex()].getAttribute('data-question'), 10);
      const pergunta = this.item.midiaEnqueteData.perguntas.find(x => x.id == perguntaId);
      if (pergunta != null && pergunta.respostaSelecionada != null) {
        this.pollSlides.lockSwipeToNext(false);
      } else {
        this.pollSlides.lockSwipeToNext(true);
      }
    } else if (type =='finish') {
      this.markAsRead(false);
      this.pollSlides.lockSwipeToNext(false);
    } else {
      this.pollSlides.lockSwipeToNext(false);
    }
  }

  calculatePaginationNext() {
    if (this.paginationVisible) {
      this.currentPage = this.currentPage + 1;
    }
    this.showHideNextPrevious();
  }

  calculatePaginationPrev() {
    if (this.paginationVisible) {
      this.currentPage = this.currentPage - 1;
    }
    this.showHideNextPrevious();
  }

  showHideNextPrevious() {
    this.paginationNextVisible = this.currentPage < this.totalPages;
    this.paginationPreviousVisible = this.currentPage > 1;
  }

  slidePrevious() {
    this.pollSlides.slidePrev();
  }

  slideNext() {
    if (this.currentPage < this.totalPages) {
      this.pollSlides.slideNext();
    }
  }

  answerPoll(pergunta: MediaEnquetePerguntaModel, selectedValue: number) {
    if (selectedValue != null) {

      this.loader = this.loadingCtrl.create({
        content: "Aguarde..."
      });
      this.loader.present();
      this.isLoading = true;

      const model = {
        clienteId: this.clientId,
        departamento: null,
        departamentoId: null,
        enqueteId: this.item.midiaEnqueteData.id,
        grupo: null,
        grupoId: null,
        id: null,
        mensagemId: this.item.id,
        organizacao: null,
        organizacaoId: null,
        perguntaId: pergunta.id,
        resposta: null,
        respostaId: selectedValue,
        team: null,
        timeId: null,
        unidade: null,
        unidadeId: null,
        usuarioId: this.userId
      };
      this.notificationService.saveEnquete(model)
        .subscribe(res => {
          pergunta.respostaSelecionada = selectedValue;
          pergunta.respondido = true;
          this.pollSlides.lockSwipeToNext(false);
          this.getPollResults(false);
        },
        err => {
          this.presentToast('Houve um erro ao gravar a resposta');
          this.loader.dismiss();
          this.isLoading = false;
        });
    } else {
      pergunta.respostaSelecionada = null;
    }
  }

  configPoll() {
    this.currentPage = 1;
    this.totalPages = this.item.midiaEnqueteData.perguntas.length + 1;
    this.paginationVisible = true;
    this.paginationPreviousVisible = false;
    this.paginationNextVisible = true;

    this.loader = this.loadingCtrl.create({
      content: "Aguarde..."
    });
    this.loader.present();
    this.isLoading = true;
    const questions = this.item.midiaEnqueteData.perguntas.map(x => x.id);
    this.notificationService.getAllRespostaEnquete(this.clientId, this.userId, this.item.id, this.item.midiaEnqueteData.id, questions)
      .subscribe(
        (items: Array<MediaEnqueteRespostaUsuarioModel>) => {
          const respostas = items.filter(x => x != null);
          this.item.midiaEnqueteData.perguntas.forEach(pergunta => {
            const resposta = respostas.find(x => x.perguntaId == pergunta.id);
            if (resposta != null) {
              pergunta.respostaSelecionada = resposta.respostaId;
              pergunta.respondido = true;
            } else {
              pergunta.respondido = false; 
            }
          });
          if (this.item.midiaEnqueteData.mostrarResultado) {
            this.getPollResults(true);
          } else {
            this.loader.dismiss();
            this.isLoading = false;
            this.controlChange();
          }
        },
        err => {
          this.presentToast('Houve um erro ao carregar as respostas');
          this.loader.dismiss();
          this.isLoading = false;
          this.controlChange();
        }
      );
  }

  getPollResults(callControlChange: boolean) {
    const questions = this.item.midiaEnqueteData.perguntas.map(x => x.id);
    this.notificationService.getAllResultadoPerguntaEnquete(this.clientId, this.item.id, this.item.midiaEnqueteData.id, questions)
      .subscribe(
        (results: Array<Array<MediaEnqueteResultadoModel>>) => {
          let allResults = new Array<MediaEnqueteResultadoModel>();
          if (results != null && results.length > 0) {
            results.forEach(r1 => {
              r1.forEach(r2 => {
                allResults.push(r2);
              });
            });
            this.item.midiaEnqueteData.perguntas.forEach(pergunta => {
              let totalRespostas = 0;
              if (allResults.length > 0) {
                const filteredResults = allResults.filter(i => i.perguntaId == pergunta.id);
                if (filteredResults.length > 0) {
                  totalRespostas = filteredResults.map(j => j.total).reduce((a, v) => a + v);
                }
              }
              pergunta.respostas.forEach(resposta => {
                const statResposta = allResults.find(i => i.respostaId == resposta.id);
                if (statResposta != null) {
                  resposta.qtdeRespostas = statResposta.total;
                  resposta.percentualRespostas = ((statResposta.total * 100) / totalRespostas).toFixed().toString() + '%';
                } else {
                  resposta.qtdeRespostas = 0;
                  resposta.percentualRespostas = '0%';
                }
                resposta.totalRespostas = totalRespostas;
              });
            });     
          }
          if (callControlChange) {
            this.controlChange();
          }
          this.loader.dismiss();
          this.isLoading = false;
        },
        err => {
          this.presentToast('Houve um erro ao carregar as estatísticas');
          if (callControlChange) {
            this.controlChange();
          }
          this.loader.dismiss();
          this.isLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/intermarketing-details/intermarketing-details.ts